<template>
  <div class="range-counter">
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <!-- <div class="range-title"></div> -->
    <van-field
      readonly
      clickable
      name="picker"
      v-model="walletName"
      :label="$t('accountLabel')"
      :placeholder="$t('accountTips')"
      :right-icon="showPicker ? 'arrow-up' : 'arrow-down'"
      @click="showPicker = true"
    />
    <van-field
      v-model="rechargeFee"
      type="number"
      @input="onInputMoney"
      :label="$t('moneyLabel')"
      :placeholder="$t('moneyTips')"
    />

    <div class="submit-btn" @click="handleSubmitRange">{{ $t("rangeConfirm") }}</div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :title="$t('moneyTips')"
        show-toolbar
        :confirm-button-text="$t('confirm')"
        :cancel-button-text="$t('orderCancel')"
        value-key="walletName"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId: "",
      customerId: "",
      walletId: "",
      walletName: "",
      rechargeFee: "",
      columns: [],
      showPicker: false,
    };
  },
  mounted() {
    this.getUsablePurse();
  },
  methods: {
    // 获取可用充值钱包
    async getUsablePurse() {
      const { data: res } = await this.$authAjax.get(
        "/api/wxapp/customer/rechargeWallet/list"
      );
      if (!res.data.length) {
        return this.$router.replace("/no/permission");
      }
      this.columns = res.data;
      this.walletName = res.data?.[0]?.walletName;
      this.walletId = res.data?.[0]?.walletId;
    },
    async handleSubmitRange() {
      if (!this.walletId) {
        return this.$toast(this.$t("accountTips"));
      }
      if (!this.rechargeFee) {
        return this.$toast(this.$t("moneyTips"));
      }
      if(this.rechargeFee == 0) {
        return this.$toast(this.$t('moneyTips2'));
      }
      try {
        this.$toast.loading({
          message:
            localStorage.getItem("language") == "CN"
              ? "加载中..."
              : "Loading...",
          forbidClick: true,
          loadingType: "spinner",
        });
        await this.$authAjax.post("/api/wxapp/customer/wallet/recharge", {
          walletId: this.walletId,
          rechargeFee: this.rechargeFee * 100,
        });
        this.$toast(this.$t("successTip"));
      } finally {
        this.$toast.clear();
      }
    },
    onInputMoney(val) {
      // 只允许数字和小数点，最多两位小数
      const formatted = val
        .replace(/[^\d.]/g, "") // 只保留数字和 .
        .replace(/^(\d*\.\d{0,2}).*$/, "$1") // 限制两位小数
        .replace(/^0+(\d)/, "$1") // 去掉多余前导 0
        .replace(/^\./, "0."); // 小数点开头变成 0.xx
      this.rechargeFee = formatted;
    },
    onConfirm(e) {
      this.walletName = e?.walletName;
      this.walletId = e?.walletId;
      this.showPicker = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.range-counter {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
  .range-title {
    margin-top: 50px;
  }
  .range-main {
    width: 100%;
    min-height: 190px;
    background: #ffffff;
    padding: 12px;
    box-sizing: border-box;
    border-radius: 0 0 6px 6px;
    .money-main {
      margin-top: 5px;
      display: flex;
      align-items: center;
      gap: 20px;
      flex-wrap: wrap;
      .monty-items {
        width: 29%;
        text-align: center;
        line-height: 50px;
        border-radius: 2px;
        color: #000;
        font-size: 13px;
        margin-top: 10px;
        background: #f6f6f6;
        font-weight: 500;
      }
    }
  }
  .submit-btn {
    width: 100%;
    height: 45px;
    background: #418ce2;
    margin-top: 30px;
    color: #fff;
    font-size: 16px;
    line-height: 45px;
    text-align: center;
  }
}
</style>
